export default __webpack_public_path__ + "logo-american-express.cee1f8.svg";